import React from 'react';

import { Icon } from '../icons';

export const ArrowBottomRightIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 16 16" fill={color} style={style}>
      <path d="M12.24 2.73645L13.3611 2.73645C13.8358 2.73645 14.2196 3.12026 14.2171 3.59245L14.2196 13.4075C14.2196 13.8822 13.8358 14.2661 13.3636 14.2635L3.54603 14.2635C3.07132 14.2635 2.6875 13.8797 2.69003 13.4075L2.69003 12.2864C2.69003 11.8066 3.08647 11.4203 3.56623 11.4304L9.50779 11.5743L2.25066 4.31716C1.91482 3.98132 1.91482 3.44095 2.25066 3.10511L3.05869 2.29708C3.39453 1.96124 3.9349 1.96124 4.27074 2.29708L11.5279 9.55422L11.3839 3.61266C11.3713 3.13036 11.7577 2.73392 12.24 2.73645Z" />
    </svg>
  );
};
